import request from 'utils/request';

// 用户登出
export const logout = () => request('/api/sso/logout', { method: 'GET' });

// 获取登录用户信息
export const getUserInfo = () => request('/api/sso/account', { method: 'GET' });
